<div class="main-container mat-typography mat-body">
  <div class="card-container">
    <div class="pharmacy-container">

      <!-- Main Container -->
      <mat-card appearance="outlined" class="find-pharmacy-card">

        <mat-card-header>
          <!-- Title -->
          <mat-card-title>
            <h2>{{title}} <small>{{subTitle}}</small></h2>
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <!-- Description -->
          <p>{{description}}</p>

          <form [formGroup]="form">
            <div class="flex-contents">

              <mat-form-field class="search" appearance="outline" [hideSingleSelectionIndicator]="true">
                <mat-label>Search for Pharmacy</mat-label>
                <input type="text" matInput formControlName="searchString" [matAutocomplete]="auto"
                  placeholder="Enter minimum 3 characters" #inputAutoComplit>
                </mat-form-field>

                <mat-autocomplete #auto="matAutocomplete">
                  @for (pharmacy of autoCompleteResults; track pharmacy) {
                    <mat-option class="pharmacy-option" [value]="pharmacy.name" appearance="outline">
                      <div class="pharmacy-result">
                        <div class="pharmacy-info">
                          <span>{{pharmacy?.name}}</span>
                          @if (pharmacy?.address1) {
                            <small>{{pharmacy?.address1}}</small>
                          }
                          @if (pharmacy?.address2) {
                            <small>{{pharmacy?.address2}}</small>
                          }
                          @if (pharmacy?.city) {
                            <small>{{pharmacy?.city}}, {{pharmacy?.state}}</small>
                          }
                        </div>
                        <div class="pharmacy-action">
                          <button mat-raised-button color="primary" class="add-pharmacy"
                            (click)="addPharmacy(pharmacy)"
                            [disabled]="selectedPharmacys.length >= maxPharmacys || pharmacy.isSelected">
                            {{ pharmacy.isSelected ? 'Added' : 'Add' }}
                          </button>
                        </div>
                      </div>
                      <mat-divider></mat-divider>
                    </mat-option>
                  }
                </mat-autocomplete>

                <mat-form-field class="radius" appearance="outline">
                  <mat-label>Search Radius</mat-label>
                  <mat-select formControlName="radius">
                    @for (rad of radius; track rad) {
                      <mat-option [value]="rad.id">
                        {{rad.value}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="zipcode" appearance="outline">
                  <mat-label>ZipCode</mat-label>
                  <input matInput formControlName="zipCode" placeholder="ex. 15221" maxlength="5">
                </mat-form-field>

                <div class="pharmacy-search">
                  @if (showSpinner) {
                    <div>
                      <mat-spinner [diameter]="36"></mat-spinner>
                    </div>
                  }
                </div>

              </div>
            </form>
          </mat-card-content>

          <!-- Selected Items -->
          <mat-card-content class="selected-pharmacys-container">
            <div class="button-and-errors">
              <div class="errors">
                <!-- ERRORS -->
                @if (autoCompleteResults.length == 0 && showNoResults) {
                  <mat-error class='no-pharmacys-found-msg'>
                    No pharmacies found
                  </mat-error>
                }
                @if (minimumCharError) {
                  <mat-error>
                    Type at least 3 characters
                  </mat-error>
                }
              </div>
            </div>

            @if (broadSearch) {
              <div class="broad-search-message">
                Your search was too broad. Try reducing your search radius.
              </div>
            }

            @if (selectedPharmacys.length > 0) {
              <mat-divider></mat-divider>
            }

            @for (pharmacy of selectedPharmacys; track pharmacy) {
              <div class="padded-item">
                <div class="pharmacy-result">
                  <div class="pharmacy-info">
                    <span>{{pharmacy?.name}}</span>
                    @if (pharmacy?.address1) {
                      <small>{{pharmacy?.address1}}</small>
                    }
                    @if (pharmacy?.address2) {
                      <small>{{pharmacy?.address2}}</small>
                    }
                    @if (pharmacy?.city) {
                      <small>{{pharmacy?.city}}, {{pharmacy?.state}}</small>
                    }
                  </div>
                  <div class="pharmacy-action">
                    <button mat-raised-button color="primary" class="remove-pharmacy"
                    (click)="removePharmacy(pharmacy)">Remove</button>
                  </div>
                </div>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
